<template>
  <div v-show="false">
    <div class="popup_wrap customModal">
      <div class="popup_title">
        <p><span id="node_title">Popup Title test</span></p>
        <a class="_command[CmmComm.closeLayer]">
          <div id="popup_close" class="btn_close" title="Close" @click="popupClose"><div class="btn_close_box"><span></span><span></span></div></div>
        </a>
      </div><!-- //popup_title -->
      <div class="popup_content1">
        <div class="node_order_wrap">
          <div class="node_order_box_left">
            <h4 class="node_order_tit">순서</h4>
            <div class="node_name_box">
              <div class="box_stitle2 node_title W100">
                <input type="text" name="node_title" class="W100 validate[required]">
              </div>
            </div>

            <h4 class="node_order_tit">속성</h4>
            <table width="100%" border="0" cellspacing="0" cellpadding="0" class="board_node">
              <colgroup>
                <col width="30%">
                <col width="*">
              </colgroup>
              <tbody>
              <tr>
                <th>속성명</th>
                <td><input type="text" class="W100 validate[required]" name="nodeSubTitle"></td>
              </tr>
              <tr>
                <th>속성타입</th>
                <td>
                  <input type="radio" class="validate[required]" name="attrType" value="inputText" id="inputText">
                  <label for="inputText">
                    String
                  </label><br>
                  <input type="radio" class="validate[required]" name="attrType" value="longText" id="longText">
                  <label for="longText">
                    Number
                  </label><br>
                </td>
              </tr>
              <tr>
                <th>속성단위</th>
                <td>
                  <input type="text" class="W100" value="℃">
                </td>
              </tr>
              <tr class="optionTr" style="display: none;">
                <th>
                  <div class="mb5">속성옵션</div>
                  <a class="btn_type1_sm _command[CmmAddAttribute.addOption]">+</a>
                </th>
                <td>
                  <div class="optionDiv"><input type="text" name="option" class="validate[required]">
                    <a class="btn_node_delete_b _command[CmmAddAttribute.delOption]">&nbsp;</a>
                    <a class="btn_node_change_b">&nbsp;</a>
                  </div>
                  <div class="optionDiv"><input type="text" name="option" class="validate[required]">
                    <a class="btn_node_delete_b _command[CmmAddAttribute.delOption]">&nbsp;</a>
                    <a class="btn_node_change_b">&nbsp;</a>
                  </div>
                  <div class="optionDiv"><input type="text" name="option" class="validate[required]">
                    <a class="btn_node_delete_b _command[CmmAddAttribute.delOption]">&nbsp;</a>
                    <a class="btn_node_change_b">&nbsp;</a>
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
            <div class="text_right mt10">
              <a class="btn_type1_sm _command[CmmAddAttribute.addAttribute]">속성추가 →</a>
            </div>
          </div>
          <div class="node_order_box_right">
            <div class="site_memo_nothing">
              <div clas="node_nothing_icon">
  <!--              <img src="/images/cyberline/basic/icon_node_nothing.png" alt="">-->
              </div>
              <div class="node_nothing_text">
                <span>왼쪽 편집창에서</span>
                노드속성을 추가해 주세요.
              </div>
            </div>
            <!-- 동적생성 div에 class="node_result_box" 추가, btn영역에 class="site_detail_con" 추가 -->
            <div id="a02c425e-48db-492f-8314-b5e461a37a15" class="node_result_box">
              <h4 class="site_detail_tit">LongText
                <div class="node_result_box_btn">
                  <a class="btn_node_delete">&nbsp;</a>
                  <a class="btn_node_change">&nbsp;</a>
                </div>
              </h4>
              <div class="site_detail_con">
                <textarea name="a02c425e-48db-492f-8314-b5e461a37a15"></textarea>
              </div>
            </div>
            <div id="f4d264ca-1f47-4a19-a300-af542d754f4c" class="node_result_box">
              <h4 class="site_detail_tit">Radio
                <div class="node_result_box_btn">
                  <a class="btn_node_delete">&nbsp;</a>
                  <a class="btn_node_change">&nbsp;</a>
                </div>
              </h4>
              <div class="site_detail_con">
                <input type="radio" name="f4d264ca-1f47-4a19-a300-af542d754f4c" id="845bb3f8-43aa-4781-8686-66af0baec5cd"
                       value="Radio1">
                <label for="845bb3f8-43aa-4781-8686-66af0baec5cd">Radio1</label><br>
                <input type="radio" name="f4d264ca-1f47-4a19-a300-af542d754f4c" id="8c480c10-a646-4c7c-9d2c-d8557e25992e"
                       value="Radio2">
                <label for="8c480c10-a646-4c7c-9d2c-d8557e25992e">Radio2</label><br>
                <input type="radio" name="f4d264ca-1f47-4a19-a300-af542d754f4c" id="8781fa3c-060f-4fb1-8402-8ecaea3bc488"
                       value="Radio3">
                <label for="8781fa3c-060f-4fb1-8402-8ecaea3bc488">Radio3</label><br>
              </div>
            </div>
            <div id="98a08c4a-e261-44ac-81c7-895c37c3ead4" class="node_result_box">
              <h4 class="site_detail_tit">Check
                <div class="node_result_box_btn">
                  <a class="btn_node_delete">&nbsp;</a>
                  <a class="btn_node_change">&nbsp;</a>
                </div>
              </h4>
              <div class="site_detail_con">
                <input type="checkbox" name="98a08c4a-e261-44ac-81c7-895c37c3ead4"
                       id="d0be9bb1-1985-427c-b6fe-5e34f5b82d40"
                       value="Check1">
                <label for="d0be9bb1-1985-427c-b6fe-5e34f5b82d40">Check1</label><br>
                <input type="checkbox"
                       name="98a08c4a-e261-44ac-81c7-895c37c3ead4"
                       id="c71e97a5-bf16-4b22-82f6-b0bad3c60c4a"
                       value="Check2">
                <label for="c71e97a5-bf16-4b22-82f6-b0bad3c60c4a">Check2</label><br>
                <input type="checkbox"
                       name="98a08c4a-e261-44ac-81c7-895c37c3ead4"
                       id="f67a585c-f5e9-4bb1-99f7-87952d3a782b"
                       value="Check3">
                <label for="f67a585c-f5e9-4bb1-99f7-87952d3a782b">Check3</label><br>
              </div>
            </div>
            <div id="dc65b6cb-e125-4c20-9567-fdc12906fbe4" class="node_result_box">
              <h4 class="site_detail_tit">첨부파일
                <div class="node_result_box_btn">
                  <a class="btn_node_delete">&nbsp;</a>
                  <a class="btn_node_change">&nbsp;</a>
                </div>
              </h4>
              <div class="site_detail_con">
                <div><input type="text">
                  <button class="coll_btn coll_btn_open"></button>
                </div>
                <ul class="attach_file_list mt5">
                  <li><a href="">첨부파일.pdf</a></li>
                  <li><a href="">AttachFile.pdf</a></li>
                  <li><a href="">첨부파일.pdf</a></li>
                </ul>
              </div>
            </div>
            <div id="800ff8e7-f000-47f8-ab2b-5460d03e987c" class="node_result_box">
              <h4 class="site_detail_tit">에디터
                <div class="node_result_box_btn">
                  <a class="btn_node_delete">&nbsp;</a>
                  <a class="btn_node_change">&nbsp;</a>
                </div>
              </h4>
              <div class="site_detail_con">
                에디터 팝업 띄우기 버튼.
              </div>
            </div>

          </div>
        </div>
      </div>
      <div class="popup_footer">
        <a class="btn_type1 _command[CmmAddAttribute.saveProc]">저장</a>
        <a class="btn_type3 _command[CmmComm.closeLayer]">닫기</a>
      </div>
    </div>
    <div class="mask_wrap" style="display:block;"></div>
    <Loading :visible="loading" type="fixed"/>
  </div>
</template>

<script>
import Loading from '@common/loading.vue';

export default {
  props: {
    visible:{
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      loading : null,
    }
  },
  components: {
    Loading,
  },
  computed: {

  },
  watch: {

  },
  async mounted() {
  },
  methods: {
    popupClose(){
      this.visible = false;
    },
  }
}
</script>

<style lang="scss">
@import "@/style/new/css/cyl.common.css";
.customModal  {display:block;position:fixed; width:1200px;height:80%;  left:50%;top:50%;transform:translate(-50%,-50%); z-index:999; box-shadow:5px 5px 20px 0px rgba(0,0,0,0.2);}
@media screen and (max-width: 1250px) {
  .customModal {width:95%;}
}
</style>